import { FC, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { userLoginSagas } from '../../../ducks/user'

// Components
import LoginForm from '../../components/Forms/Login'
import Logo from '../../components/UI/Logo'
import { Button } from '../../components/UI/Buttons'
import { useNotification } from 'lib/context/notification.context'
// selector
import { errorSelector } from '../../../ducks/user'
// actions
import { setError } from 'ducks/user'

import { useTranslation } from 'react-i18next'
import {
  Container,
  LoginActionRow,
  LoginDescription,
  LoginEyebrow,
} from './styled'
import { IOS_DEVICE } from 'constants/global.constants'

const iOS = IOS_DEVICE.test(navigator.userAgent)

interface LoginFormContainerProps {
  variant?: 'admin' | 'evaluated'
}

const LoginFormContainer: FC<LoginFormContainerProps> = ({ variant = 'admin' }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const error = useSelector(errorSelector)

  const { getWarning } = useNotification()

  const handleResize = () => {
    window.scrollTo(0, 0)
  }

  useEffect(() => {
    if (iOS) {
      window.addEventListener('resize', handleResize)

      handleResize()

      return () => {
        window.removeEventListener('resize', handleResize)
      }
    }
  }, [])

  const handleLogin = (values: any): void => {
    dispatch(userLoginSagas.run({ email: values.email.toLowerCase(), password: values.password }))
  }

  useEffect(() => {
    dispatch(setError(false))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (error) {
      if (error.code === '401') {
        getWarning(t('global.notifications.loginEmailOrPasswordErrorMessage'))
      } else if (error.code === '421') {
        getWarning(t('global.notifications.loginInactiveUserErrorMessage'))
      } else if (error.code === '420') {
        getWarning(t('global.notifications.loginEmailNotMainErrorMessage'))
      } else if (error.code === '422') {
        getWarning(t('global.notifications.deactivateAccountErrorMessage'))
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error, getWarning])

  const isEvaluated = variant === 'evaluated'

  return (
    <Container>
      <Logo width="245px" />
      <LoginEyebrow>{isEvaluated ? 'Acceso para evaluados' : 'Acceso seguro para administradores'}</LoginEyebrow>
      <LoginDescription>
        {isEvaluated
          ? 'Ingresa para contestar tus pruebas en una experiencia más clara, enfocada y fácil de seguir.'
          : 'Ingresa para gestionar talento, procesos, analítica y desarrollo con una experiencia más sólida.'}
      </LoginDescription>
      <LoginForm onSubmit={(e) => handleLogin(e)} />
      <LoginActionRow>
        {isEvaluated ? (
          <Button variant="ghost" size="md" onClick={() => navigate('/login')}>
            Volver al acceso de administración
          </Button>
        ) : (
          <Button
            variant="secondary"
            size="md"
            onClick={() => navigate('/login/evaluated')}
            background="linear-gradient(180deg, #F2F9EC 0%, #E9F7DD 100%)"
            color="#34651A"
            border="1px solid #BEE1A6"
          >
            Voy a contestar pruebas
          </Button>
        )}
      </LoginActionRow>
    </Container>
  )
}

export default LoginFormContainer
